<template>
    <el-container id="tab">
        <el-aside :width="isCollapse ? '20px' : '230px'">
            <el-card v-show="!isCollapse" class="box-card">
                <div slot="header">
                    <span>查询条件</span>
                    <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
                </div>
                <el-form ref="queryFormRef" :model="queryForm" :rules="queryFormRules" size="small">
                    <el-scrollbar>
                        <el-form-item label="客户" prop="customer.selected">
                            <select-multiple class="query_form_item" :select-data="queryForm.customer" :change="() => { getBalanceAmt('customer') }" :isClear="false" isTable :column-list="selectMultipleTableColumnListCommon.customer"></select-multiple>
                        </el-form-item>
                        <el-form-item>
                            <p class="amt-info">
                                <span>欠款：{{ balanceAmt.arrearAmt || 0 }}元</span>
                                <span>预收：{{ balanceAmt.prePayAmt || 0 }}元</span>
                            </p>
                        </el-form-item>
                        <el-form-item label="品牌" prop="brand.selected">
                            <select-multiple class="query_form_item" ref="brand" :select-data="queryForm.brand" :change="() => { getBalanceAmt('brand') }" :isClear="false"></select-multiple>
                        </el-form-item>
                        <el-form-item label="经手人" prop="salesman.selected">
                            <select-multiple class="query_form_item" ref="salesman" :select-data="queryForm.salesman" :change="() => { multipleChange('salesman') }"></select-multiple>
                        </el-form-item>
                        <el-form-item label="备注" prop="remark.selected">
                            <el-input v-model="queryForm.remark.selected" ref="remark" type="textarea" :autosize="{ minRows: 2 }" clearable placeholder="请输入备注"></el-input>
                        </el-form-item>
                    </el-scrollbar>
                </el-form>
            </el-card>
            <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
                <span style="text-align: center;">查询</span>
                <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
                <span style="text-align: center;">条件</span>
            </div>
        </el-aside>
        <el-main>
            <div class="main-box">
                <el-form ref="form" :model="queryForm" label-width="90px">
                    <el-form-item label="调整类型">
                        <el-select v-model="queryForm.type.selected" placeholder="请选择调整类型">
                            <el-option label="应收款" value="A"></el-option>
                            <el-option label="预收款" value="B"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="调整前金额">
                        <el-input v-model="queryForm.beforeAdjust.selected" style="width: 240px;" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="调整金额">
                        <el-input v-model="queryForm.adjust.selected" style="width: 240px;" @blur="inputBlur($event, 'adjust', 'afterAdjust')" @input="inputChange($event, 'adjust')"></el-input>
                    </el-form-item>
                    <el-form-item label="调整后金额">
                        <el-input v-model="queryForm.afterAdjust.selected" style="width: 240px;" @blur="inputBlur($event, 'afterAdjust', 'adjust')" @input="inputChange($event, 'afterAdjust')"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-dropdown split-button type="primary" @click="onSubmit" @command="onSubmit">
                          提交
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="A">提交并打印</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                    </el-form-item>
                </el-form>
            </div>
        </el-main>
    </el-container>
</template>
<script>
export default {
    components: {},
    mixins: [selectMultipleTableColumnListCommonMixins],
    data() {
        return {
            isCollapse: false,
            queryForm: {
                customer: { submitName: 'customer', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                salesman: { submitName: 'salesmanID', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择经手人', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                remark: { submitName: 'remark', selected: '' },
                brand: { submitName: 'financialBrand', selected: { value: '2010010101010000000', text: '综合品牌' }, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
                type: { submitName: 'type', selected: '' },
                beforeAdjust: { submitName: 'beforeAdjust', selected: 4 },
                adjust: { submitName: 'adjust', selected: '' },
                afterAdjust: { submitName: 'afterAdjust', selected: '' },
            },
            queryFormRules: {
                'customer.selected': [
                    { required: true, message: '请选择门店', trigger: 'blur' }
                ],
            },
            balanceAmt: {
                prePayAmt: 0,
                arrearAmt: 0
            },
            form: {

            }
        }
    },
    created() {
        // this.getUserList()
    },
    methods: {
        async getUserList() {
            this.loading = true
            const { data: res } = await this.$http.post(this.selectUser.url, this.Qs.stringify(this.selectUser))
            this.loading = false
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.wareHouseList = JSON.parse(res.result.data)
            this.total = res.result.total
        },
        async getBalanceAmt(tag) {
            return false
            const { data: res } = await this.$http.post('/Account/salPayVue/queryCustomerBalanceAmt.html', this.Qs.stringify(this.queryitem))
            if (res.code != 'success') return this.$message.error(res.message)
            this.multipleChange()
            let data = JSON.parse(JSON.parse(res.result).data)
            this.balanceAmt = data ? data : { prePayAmt: 0, arrearAmt: 0 }
        },
        multipleChange(tag) {

        },
        inputChange(val, tag) {
            if (val) {
                val = val.replace(/[^\d|\.]/g, '')
                this.queryForm[tag].selected = val
            }
        },
        inputBlur(e, current, next) {
            if (next == 'adjust') { //输入调整后金额
                this.queryForm[next].selected = Number(this.queryForm[current].selected) - Number(this.queryForm[current].selected)
            } else if (next == 'afterAdjust') {
                this.queryForm[next].selected = Number(this.queryForm[current].selected) + Number(this.queryForm[current].selected)
            }
        },
        onSubmit() {

        }
    }
}
</script>
<style scoped lang="less">
#tab {
    .box-card {
        display: flex;
        flex-flow: column;
        height: calc(100% - 2px);

        ::v-deep .el-card__header {
            padding: 8px 20px;
            height: 33px;
            background-color: #F5F7FA;
            color: #409EFF;
        }

        ::v-deep .el-card__body {
            padding: 6px;
            flex: 1;
            box-sizing: border-box;
            overflow-y: auto;
        }
    }

    .el-aside {
        ::v-deep .el-card__body {
            .el-form {
                height: 100%;

                .el-scrollbar {
                    height: 100%;
                }

                .el-form-item {
                    margin: 18px 0 0;
                    position: relative;

                    .el-form-item__label {
                        position: absolute;
                        z-index: 2;
                        top: -12px;
                        margin-left: 10px;
                        padding: 0 6px;
                        line-height: normal;
                        background-color: #fff;
                    }

                    .amt-info {
                        border: 1px #F56C6C solid;
                        color: #F56C6C;

                        span {
                            display: block;
                            text-align: center;
                        }
                    }
                }
            }

            .calculation-form {
                .el-form-item {
                    text-align: center;

                    .el-form-item__label {
                        margin: 0;
                        left: 36px;
                    }

                    .input-with-select {
                        .el-input-group__prepend {
                            padding: 0 12px;
                            background-color: #fff;

                            .select-multiple {
                                display: inline-block;
                                width: 50px;
                            }
                        }
                    }

                    .el-input-number .el-input__inner {
                        text-align: left;
                    }
                }
            }
        }

        .is-collapse {
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
            border: 1px #DCDFE6 solid;
            cursor: pointer;
            background-color: rgba(83, 168, 255, 0.1);
            color: #409EFF;
        }

        .select_multiple {
            ::v-deep .el-select__tags {
                max-height: 80px;
                overflow-y: auto;
                overflow-x: hidden;
            }
        }
    }

    .el-main {
        padding: 0 0 0 12px;

        .main-box {
            width: calc(100% - 42px);
            height: calc(100% - 22px);
            padding: 10px 20px;
            border: 1px solid #EBEEF5;
            border-radius: 4px;
            overflow-y: auto;
            overflow-x: hidden;

            /deep/.el-input.is-disabled {
                .el-input__inner {
                    color: #606266;
                }
            }
        }
    }
}
</style>